import React from 'react';
import { withSessionSsr, getPublicToken } from "../../lib/sessionMiddleware";
import { getCanonicalPath } from "../../lib/canonical";
import useHook from '../../hooks/pages/carrito/useHook';
import styles from './styles.module.scss';
import {
  Wrapper,
  TituloSeccion,
  Seccion,
  Footer,
  Loader,
  HeadTags,
  BtnFlotanteWhatsapp,
  ItemCarrito,
  CarritoVacio,
  Link,
  Navbar,
}from '../../components';

import {
  Button,
  useTheme,
  Snackbar,
  Portal,
} from '@mui/material';
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';
import {currency} from '../../utils/utils';
import {parseItemsQuery} from '../../utils/carritoCompartido';

const CarritoPage = (props)=>{
    
  const theme = useTheme();

  const {
    mobile,
    loadingProductos,
    productos,
    total,
    showSnackbar,
    snackbarMessage,
    setShowSnackbar,
    compartirCarrito,
  } = useHook({ sharedCartItems: props.pageProps.sharedCartItems });
    
  return(<>

    <HeadTags
      title="Mi carrito"
      description=""
      path={props.pageProps.pathname}
      noIndex={true}
    />

    <Navbar/>

    <Seccion padding="40px 20px" paddingMobile="20px">
      <Wrapper>             
        <TituloSeccion align="center">Mi carrito</TituloSeccion>
        <br/><br/>  
        {loadingProductos ?
          <Loader
            spinner={true}
            skeleton={false}
            variant="rectangular"
            width={!mobile ? 1400 : 480}
            height={!mobile ? 300 : 400}
            color="secondary"
            opacity="1"
          />
          :
          productos?.length > 0 ?
            <div className={styles.contenedor}>
              {productos?.map(item=>(
                <ItemCarrito data={item} key={item.producto.id} />
              ))}
              <div className={styles.totalizador}>
                <h3>Total: <b>${currency(total)}</b></h3>
              </div>
              <Link href="/checkout" className={styles.ctaWrapper}>
                <Button
                  color="otherPink2"
                  variant="contained"
                  style={{
                    padding: "16px 36px",
                    display: "flex",
                    gap: "12px",
                    width: mobile ? "100%" : "240px"
                  }}
                >Continuar</Button>
              </Link>
              <Button
                color="otherPink2"
                variant="text"
                startIcon={<ShareOutlinedIcon/>}
                onClick={compartirCarrito}
                style={{
                  padding: "12px 24px",
                  display: "flex",
                  gap: "12px",
                  width: mobile ? "100%" : "240px",
                  marginTop: "8px"
                }}
              >Compartir carrito</Button>
            </div>
            : <CarritoVacio
              mensaje="Tu carrito está vacío."
              ctaHref="/tienda"
              ctaLabel="Ir a la tienda"
            />
        }

      </Wrapper>
    </Seccion>

    <br/><br/><br/>
        
    <Footer/>

    <BtnFlotanteWhatsapp/>

    {(typeof document !== "undefined") && <>
      <Portal container={document.getElementById("portal")}>
        <Snackbar
          open={showSnackbar}
          autoHideDuration={4000}
          message={snackbarMessage}
          onClose={() => setShowSnackbar(false)}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center"
          }}
        />
      </Portal>
    </>}
  </>);
};

export default CarritoPage;

export const getServerSideProps = withSessionSsr(
  async function getServerSideProps(ctx) {

    const { req } = ctx;

    const publicToken = await getPublicToken(req);

    const pedidos = parseItemsQuery(ctx.query.items);
    let sharedCartItems = [];
    if (pedidos.length > 0) {
      try {
        const result = await fetch(`${process.env.NEXT_PUBLIC_URL_FRONTEND}/api/productos/get-filtered`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-spiral-secret': process.env.SPIRAL_SECRET,
          },
          body: JSON.stringify({ ids: pedidos.map((p) => p.id) }),
        });
        const data = await result.json();
        sharedCartItems = (data?.data || []).map((producto) => ({
          producto,
          cantidad: pedidos.find((p) => p.id === producto.id)?.cantidad || 1,
        }));
      } catch (err) {
        console.log('Error trayendo carrito compartido:', err);
      }
    }

    return {
      props: {
        pathname: getCanonicalPath(req),
        sharedCartItems,
      },
    };

  },
);